<template>
  <aside class="aside-menu px-3 pt-3">
    <!--
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#timeline" role="tab"><i class="icon-list"></i></a>
      </li>
      <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#messages" role="tab"><i class="icon-speech"></i></a>
      </li>
      <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#settings" role="tab"><i class="icon-settings"></i></a>
      </li>
    </ul>
    -->

    <h6>Chat Message
      <label class="switch switch-text switch-pill switch-success switch-sm float-right">
        <small class="text-muted" style="font-size: 9px;" @click="asideToggle">Fechar</small>
        </label>
    </h6>

    <hr>
    <!--<small class="text-muted">Indisponível</small>-->

  </aside>
</template>

<script>
export default {
  name: 'AppAside',
  methods: {
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/layout/Aside.vue